import React from 'react';
import PropTypes from 'prop-types';

import { THEMES } from 'App/config';
import { slugify } from '../../app/general';

const offerItems = [
  {
    title: 'Czym jest OtoStolik?',
    desc: 'OtoStolik jest lubelską firmą, działamy na rynku od września 2019. Świadczymy usługi dla restauracji w zakresie rezerwacji online, zamówień online z dowozem lub odbiorem osobistym, obecnie współpracujemy z ponad 25. restauracjami.',
    availableForThemes: [THEMES.OtoStolik],
  },
  {
    title: 'Czym jest LUB*JE?',
    custom: <>
      <p>Polskim portalem, założonym przez lubelskich restauratorów we współpracy z lokalną firmą technologiczną OtoStolik.</p>
      <p>Robimy gastronomię lepszym miejscem, dostarczając zamawiającym wygodnego narzędzia i dbając o marketing, lecz jednocześnie pozwalając restauracjom na zatrzymanie zarobków u siebie, zamiast oddawanie ich zagranicznym korporacjom.</p>
    </>,
    availableForThemes: [THEMES.LUBJE],
  },
  {
    title: 'Jak rozpocząć współpracę?',
    custom: <>
      <div>
        Wejdź na: <a href="https://admin.otostolik.pl/signup" target="_blank" rel="noopener noreferrer">admin.otostolik.pl/signup</a> i uzupełnij formularz, a założymy Ci konto w niecałe <span className="text-primary">24 godziny!</span>
      </div>
    </>,
    availableForThemes: [THEMES.OtoStolik],
  },
  {
    title: 'Jak dodać restaurację do LUB*JE?',
    custom: <>
      <h4 class="h6">Dla nowych restauracji:</h4>
      <div>
        Wejdź na: <a href="https://admin.otostolik.pl/signup" target="_blank" rel="noopener noreferrer">admin.otostolik.pl/signup</a> i uzupełnij formularz, a założymy Ci konto w niecałe <span className="text-primary">24 godziny!</span>
      </div>
      <hr />
      <h4 class="h6">Dla restauracji, posiadających konto OtoStolik:</h4>
      <div>Nie potrzebujesz nowego konta, ani aplikacji - możesz przyjmować zamówienia z LUB*JE z dobrze Ci znanego systemu do zarządzania restauracją OtoStolik.</div>
      <div>
        Napisz na <a href="mailto:wspolpraca@lubje.pl">wspolpraca@lubje.pl</a>, a przygotujemy dla Ciebie umowę i dodamy do listy restauracji.
      </div>
    </>,
    availableForThemes: [THEMES.LUBJE],
  },
  {
    title: 'Ile to kosztuje?',
    desc: '8% netto od wartości zamówienia. Brak opłat wstępnych, dodatkowych lub stałych. Przejrzyste zasady i prosta umowa.',
    availableForThemes: [THEMES.LUBJE],
  },
  {
    title: 'Ile to kosztuje?',
    custom: <table className="table table-striped" style={{ border: '2px solid' }}>
      <tbody>
        <tr>
          <td>Prowizja za zamówienia z własnej strony www</td>
          <td>
            5% od wartości zamówienia
          </td>
        </tr>
        <tr>
          <td>Prowizja za zamówienia z portalu OtoStolik.pl</td>
          <td>
            9% od wartości zamówienia
          </td>
        </tr>
        <tr>
          <td>Dodanie restauracji do portalu</td>
          <td>brak opłaty</td>
        </tr>
        <tr>
          <td>Stworzenie strony www dla restauracji</td>
          <td>wycena indywidualna, <span className="text-primary">już od 0zł!</span></td>
        </tr>
        <tr>
          <td>Prowizja za płatności online</td>
          <td>1.5%</td>
        </tr>
      </tbody>
    </table>,
    commissionOnly: true,
    availableForThemes: [THEMES.OtoStolik],
  },
  {
    title: 'Ile to kosztuje?',
    custom: <table className="table table-striped" style={{ border: '2px solid' }}>
      <tbody>
        <tr>
          <td>zamówienia z własnej strony www</td>
          <td>
            stały abonament, w zależności od liczby zamówień
          </td>
        </tr>
        <tr>
          <td>Prowizja za zamówienia z portalu OtoStolik.pl (opcjonalnie)</td>
          <td>
            9% od wartości zamówienia
          </td>
        </tr>
        <tr>
          <td>Dodanie restauracji do portalu</td>
          <td>brak opłaty</td>
        </tr>
        <tr>
          <td>Stworzenie strony www dla restauracji</td>
          <td>wycena indywidualna, <span className="text-primary">już od 0zł!</span></td>
        </tr>
        <tr>
          <td>Prowizja za płatności online</td>
          <td>1.5%</td>
        </tr>
      </tbody>
    </table>,
    subscriptionOnly: true,
    availableForThemes: [THEMES.OtoStolik],
  },
  {
    title: 'Rozliczenia i rachunkowość',
    custom: <>
      <div>Mamy proste zasady - wypłacamy Ci pieniądze z zamówień online raz w tygodniu, potrącając prowizję.</div>
      <div>Raz w miesiącu wystawimy fakturę. Czy może być prościej?</div>
      <small>Na żądanie możemy ustalić inny okres rozliczeniowy.</small>
    </>
  },
  {
    title: 'Jak odbierać zamówienia',
    custom: <>
      <p>Wystarczy dowolne urządzenie z dostępem do Internetu.</p>
      <p>Dla maksymalnej wygody użytkowania zalecamy użycie tableta lub smartfona z systemem Android.</p>
      <p>W wypadku użycia urządzenia z iOS może być konieczne ciągłe trzymanie urządzenia przy ładowaniu.</p>
    </>
  },
  {
    title: 'Czy otrzymam urządzenie do przyjmowania zamówień?',
    custom: <>
      <p>Nie potrzebujesz osobnego urządzenia - system OtoStolik odpalisz na dowolnym sprzęcie z dostępem do Sieci.</p>
      <p>Jeżeli jednak potrzebujesz osobnego urządzenia - zapytaj naszego przedstawiciela o taką możliwość.</p>
      <p>Po otrzymaniu zamówienia nabij go do POS'a, podobnie jak zamówienie telefoniczne.</p>
      <p>W razie potrzeby możemy zintegrować z drukarką Bluetooth <a href="https://allegro.pl/oferta/przenosna-drukarka-termiczna-bluetooth-58-mm-10161100959" target="_blank" rel="noopener noreferrer">(przykład drukarki)</a></p>
    </>
  }
];

const listStyle = {
  border: '1px solid var(--primary)',
  borderRadius: 5,
  display: 'inline-block',
  margin: 20,
  padding: '10px 10px 10px 30px',
  maxWidth: 500,
};

const mw700 = {
  maxWidth: 700,
}

const RestaurateurFaq = ({ isSubscription = false, theme = THEMES.OtoStolik }) => {
  const filterByTheme = item => !item.availableForThemes || item.availableForThemes.includes(theme);
  const filterByPricingStrategy = item => {
    if (isSubscription && item.commissionOnly) {
      return false;
    }
    if (!isSubscription && item.subscriptionOnly) {
      return false;
    }
    return true;
  };
  const filteredOfferItems = offerItems
    .filter(filterByTheme)
    .filter(filterByPricingStrategy);

  return <div className="d-flex flex-column align-items-center">
    <ol style={listStyle}>
      {
        filteredOfferItems
          .map(item => <li key={item.title}>
            <a href={`#${slugify(item.title)}`} className="js-scroll-trigger">{item.title}</a>
          </li>)
      }
    </ol>
    <hr />
    <div className="container" style={mw700}>
      {
        filteredOfferItems
          .map(item => <article key={item.title}>
            <h3 id={slugify(item.title)} className="mt-5">{item.title}</h3>
            {item.desc && <p>{item.desc}</p>}
            {item.custom}
          </article>)
      }
    </div>
  </div>;
};

RestaurateurFaq.propTypes = {
  isSubscription: PropTypes.bool,
  theme: PropTypes.string,
}

export default RestaurateurFaq;
